import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationService } from './animation.service';
import { UtmService } from './utm.service';
import { ResizeService } from './resize.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AnimationService,
    UtmService,
    ResizeService,
  ]
})
export class UtilsModule { }
